<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/RechargeList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资金明细</el-breadcrumb-item>
          <el-breadcrumb-item>毛利润月报表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="5" class="display-row">
            <div class="query-title">时间:</div>
            <div class="flex1">
              <el-date-picker v-model="date" value-format="yyyyMM" unlink-panels type="monthrange" range-separator="至"
                start-placeholder="开始月份" end-placeholder="结束月份">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="19" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px; floate: right">
              <el-button class="search-btn lx-mb5 btn-blue" @click="toExport">导出</el-button>
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <div class="tips">
          <span class="tip-item">总毛利润：{{ addThousandSeparator(form.totalGrossProfit) }}元</span>
        </div>
        <el-table :data="recordList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle"
          border height="550">
          <el-table-column min-width="65" prop="date" align="center" label="时间">
            <template v-slot="{ row }">
              {{ convertToMonth(row.date) }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="实际结汇记录" min-width="200">
            <template v-slot="{ row }">
              <div class="jiehui">
                <div v-for="(item , index) in row.actualReceivedFeeList" :key="index">
                  <el-input v-model="row.actualReceivedFeeList[index]" placeholder="请输入金额" size="mini" @change="quickSave(row)" @blur="addactualTsof(row, index)"
                  @focus="removeactualTsof(row, index)">
                    <template slot="append">元</template>
                  </el-input>
                </div>
                <div class="but-jia"> <el-button style="color: #909399;" size="mini" @click="addFeeList(row)">+</el-button></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="actualReceivedFee" align="center" label="实际到账金额" class-name="table-green">
            <template v-slot="scope">
              <div style="width: 100%; text-align: right">{{
            addThousandSeparator(scope.row.actualReceivedFee?.toFixed(2)) }}</div>
            </template>
          </el-table-column>
          <el-table-column width="102" prop="rechargeFee" align="center" class-name="table-green">
            <template v-slot:header> 充值金额<br /><span style="font-size: 12px">(银行+PAYPAL)</span></template>
            <template v-slot="scope">
              <div style="width: 100%; text-align: right">{{ addThousandSeparator(scope.row.rechargeFee?.toFixed(2)) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="125" prop="purchaseFee" align="center" class-name="table-green">
            <template v-slot:header> 客户采购金额<br /><span style="font-size: 12px">(含国内运费)</span></template>
            <template v-slot="scope">
              <div style="width: 100%; text-align: right;margin-bottom: 5px;">{{
            addThousandSeparator(scope.row.purchaseFee?.toFixed(2)) }}</div>
              <el-input v-model="scope.row.actualPurchaseFee" placeholder="请输入金额" size="mini"
                @change="quickSave(scope.row)" @blur="addTsof(scope.row, 'actualPurchaseFee')"
                @focus="removeTsof(scope.row, 'actualPurchaseFee')">
              </el-input>
              <div v-if="scope.row.actualPurchaseFee" style="width: 100%; text-align: right;margin-top: 5px;"
                :class="scope.row.purchasePnlFee >= 0 ? 'fee-green' : 'fee-red'">{{
            addThousandSeparator(scope.row.purchasePnlFee?.toFixed(2)) }}</div>
            </template>
          </el-table-column>
          <el-table-column width="90" prop="agentServiceFee" align="center" label="代购手续费" class-name="table-green">
            <template v-slot="scope">
              <div style="width: 100%; text-align: right;">{{
            addThousandSeparator(scope.row.agentServiceFee?.toFixed(2)) }}</div>
            </template>
          </el-table-column>
<!--          <el-table-column min-width="105" prop="inspectionFee" align="center" class-name="table-green">
            <template v-slot:header> 检品费</template>
            <template v-slot="scope">
              <div style="width: 100%; text-align: right;margin-bottom: 5px;padding-right: 9px;">{{
            addThousandSeparator(scope.row.inspectionFee?.toFixed(2)) }}</div>
              <el-input v-model="scope.row.actualInspectionFee" placeholder="请输入金额" size="mini"
                @change="quickSave(scope.row)" @blur="addTsof(scope.row, 'actualInspectionFee')"
                @focus="removeTsof(scope.row, 'actualInspectionFee')">
              </el-input>
              <div v-if="scope.row.actualInspectionFee" style="width: 100%; text-align: right;margin-top: 5px;padding-right: 9px;"
                :class="scope.row.inspectionPnlFee >= 0 ? 'fee-green' : 'fee-red'">{{
            addThousandSeparator(scope.row.inspectionPnlFee?.toFixed(2)) }}</div>
            </template>
          </el-table-column>-->
          <el-table-column min-width="100" prop="internationalFreight" align="center" label="国际运费"
            class-name="table-green">
            <template v-slot="scope">
              <div style="width: 100%; text-align: right;margin-bottom: 5px;padding-right: 9px;">{{
            addThousandSeparator(scope.row.internationalFreight?.toFixed(2)) }}</div>
              <el-input v-model="scope.row.actualInternationalFreight" placeholder="请输入金额" size="mini"
                @change="quickSave(scope.row)" @blur="addTsof(scope.row, 'actualInternationalFreight')"
                @focus="removeTsof(scope.row, 'actualInternationalFreight')">
              </el-input>
              <div v-if="scope.row.actualInternationalFreight" style="width: 100%; text-align: right;margin-top: 5px;padding-right: 9px;"
                :class="scope.row.internationalPnlFreight >= 0 ? 'fee-green' : 'fee-red'">{{
            addThousandSeparator(scope.row.internationalPnlFreight?.toFixed(2)) }}</div>
            </template>
          </el-table-column>
           <el-table-column min-width="100" prop="otherFee" align="center" label="其他" class-name="table-red">
            <template v-slot="scope">
              <el-input v-model="scope.row.otherFee" placeholder="请输入金额" size="mini"
                @change="quickSave(scope.row)" @blur="addTsof(scope.row, 'otherFee')"
                @focus="removeTsof(scope.row, 'otherFee')">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column min-width="100" prop="wageFee" align="center" label="人工费" class-name="table-red">
            <template v-slot="scope">
              <el-input v-model="scope.row.wageFee" placeholder="请输入金额" size="mini"
                @change="quickSave(scope.row)" @blur="addTsof(scope.row, 'wageFee')"
                @focus="removeTsof(scope.row, 'wageFee')">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="grossProfit" align="center" class-name="table-yellow" min-width="95">
            <template v-slot:header>
              <div>
                <span>毛利润</span>
                <el-tooltip content="毛利润 = 客户采购利润 + 代购手续费 + 国际运费利润 - 其他 - 人工费" placement="bottom-start" effect="light">
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </div>
            </template>
            <template v-slot="scope">
              <div style="width: 100%; text-align: right">{{ addThousandSeparator(scope.row.grossProfit?.toFixed(2)) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum" :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";

export default {
  components: { tableCon },
  name: "orderAmountSummary",
  data() {
    return {
      date: "",
      queryInfo: {
        startDate: "",
        endDate: "",
        pageSize: 10,
        pageNum: 1,
      },
      recordList: [],
      total: 0,
      form: {},
      currentdate: '',
    };
  },
  methods: {
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    async getrecordList() {
      const { data: res } = await this.$http.get("/amountReport/list", { params: this.queryInfo });
      this.recordList = res.data.list;
      this.total = res.data.total;
      this.recordList.forEach((item) => {
        item.actualPurchaseFee = this.addThousandSeparator(item.actualPurchaseFee?.toFixed(2));
        item.actualInspectionFee = this.addThousandSeparator(item.actualInspectionFee?.toFixed(2));
        item.actualInternationalFreight = this.addThousandSeparator(item.actualInternationalFreight?.toFixed(2));
        item.wageFee = this.addThousandSeparator(item.wageFee?.toFixed(2));
        item.otherFee = this.addThousandSeparator(item.otherFee?.toFixed(2));
        item.actualReceivedFeeList = item.actualReceivedFeeList.map(item => {
          return this.addThousandSeparator(item?.toFixed(2));
        })
      })
      await this.getTool();
    },
    async getTool() {
      const { data: res } = await this.$http.get('/amountReport/amountReportHeader', { params: this.queryInfo });
      this.form = res.data
    },
    async quickSave(row) {
      row.actualPurchaseFee = parseFloat(row.actualPurchaseFee?.replace(/,/g, ''));
      row.actualInspectionFee = parseFloat(row.actualInspectionFee?.replace(/,/g, ''));
      row.actualInternationalFreight = parseFloat(row.actualInternationalFreight?.replace(/,/g, ''));
      row.wageFee = parseFloat(row.wageFee?.replace(/,/g, ''));
      row.otherFee = parseFloat(row.otherFee?.replace(/,/g, ''));
      row.actualReceivedFeeList = row.actualReceivedFeeList.map(item => {
        return parseFloat(item?.replace(/,/g, ''));
      })
      const { data: res } = await this.$http.post("/amountReport/updateAction", row);
      if (res.code == 200) {
        this.$message.success("保存成功");
        this.getrecordList();
      } else {
        this.$message.error(res.msg);
      }
    },
        // 当前日期
        getNowFormatDate () {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      if (month >= 1 && month <= 9) month = '0' + month // 如果月份是个位数，在前面补0
      if (strDate >= 0 && strDate <= 9) strDate = '0' + strDate // 如果日是个位数，在前面补0
      this.currentdate = `${year}${month}${strDate}${hour}${minute}${second}`
    },
    // 导出
    toExport() {
      if (this.date) {
        this.queryInfo.startDate = this.date[0];
        this.queryInfo.endDate = this.date[1];
      } else {
        this.queryInfo.startDate = "";
        this.queryInfo.endDate = "";
      }
      this.getNowFormatDate()
      this.$http({
        url: "/amountReport/exportAction",
        method: "get",
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
        params: this.queryInfo,
        data: {
          //接口参数
        },
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement("a")
        let blob = new Blob([res.data], {type: "application/vnd.ms-excel"})
        link.style.display = "none"
        //设置连接
        link.href = URL.createObjectURL(blob)
        link.download = `毛利润月报表${this.currentdate}.xlsx`
        document.body.appendChild(link)
        //模拟点击事件
        link.click()
      }).catch((err) => {
        // console.log(err);
      })
    },
    addFeeList(row) {
      row.actualReceivedFeeList.push('');
    },
    addTsof(row, key) {
      this.recordList.forEach(item => {
        if (item.id === row.id) {
          console.log(typeof (item[key]));
          if (typeof (item[key]) != 'number') {
            item[key] = ''
            this.getrecordList();
            return this.$message.warning('请输入数字金额');
          }
          item[key] = this.addThousandSeparator(item[key]?.toFixed(2));
        }
      })
    },
    removeTsof(row, key) {
      this.recordList.forEach(item => {
        if (item.id === row.id) {
          item[key] = parseFloat(item[key].replace(/,/g, ''));
        }
      })
    },
    addactualTsof(row, key) {
      this.recordList = this.recordList.map(item => {
        if (item.id === row.id) {
          if (typeof (item.actualReceivedFeeList[key]) != 'number') {
            item.actualReceivedFeeList[key] = '';
            this.getrecordList();
            this.$message.warning('请输入数字金额');
            return item;
          }
          // 创建新数组以确保响应式更新
          const newList = [...item.actualReceivedFeeList];
          newList[key] = this.addThousandSeparator(item.actualReceivedFeeList[key]?.toFixed(2));
          return {
            ...item,
            actualReceivedFeeList: newList
          };
        }
        return item;
      });
    },
    removeactualTsof(row, key) {
      this.recordList = this.recordList.map(item => {
        if (item.id === row.id) {
          item.actualReceivedFeeList[key] = parseFloat(item.actualReceivedFeeList[key]?.replace(/,/g, ''));
        }
        return {...item};
      })
    },
    searchList() {
      if (this.date) {
        this.queryInfo.startDate = this.date[0];
        this.queryInfo.endDate = this.date[1];
      } else {
        this.queryInfo.startDate = "";
        this.queryInfo.endDate = "";
      }
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    queryInfoClear() {
      this.date = "";
      this.queryInfo = {
        startDate: "",
        endDate: "",
        pageSize: 10,
        pageNum: 1,
      };
    },
    convertToMonth(dateStr) {
      return dateStr.slice(0, 4) + "-" + dateStr.slice(4);
      // return dateStr.slice(-2).replace(/^0/, "") + "月";
    },
  },
  activated() {
    this.getrecordList();
  },
  created() {
    this.getrecordList();
  },
};
</script>
<style lang="less" scoped>
.jiehui {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
  width: 100%;
  padding: 0;
}

.jiehui-input {
  margin-top: 5px;
}

.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.tips {
  margin: 15px 0;
  text-align: right;
}

.tip-item {
  margin-left: 30px;
}

.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.role-page>.search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}

.toolTipClass {
  width: auto;
  max-width: 200px;
}

::v-deep(.el-input-group__append, .el-input-group__prepend) {
  padding: 0 5px;
}

::v-deep(.el-input__inner) {
  padding: 0 7px;
  text-align: right;
}

.flex1 {
  ::v-deep(.el-input--prefix .el-input__inner) {
    padding-left: 30px;
  }
}

::v-deep(.table-green) {
  background-color: #7fffd424;
}

::v-deep(.table-red) {
  background-color: #ff000017;
}

::v-deep(.table-yellow) {
  background-color: #96df4180;
}

::v-deep(.el-date-editor .el-range-separator) {
  width: 25px;
}

.query-title {
  width: 55px;
}

.fee-red {
  color: red;
}

.fee-green {
  color: #0dbc79;
}
.but-jia{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
::v-deep(.el-input--mini .el-input__inner){
  font-size: 14px
}

.cp{
  cursor: pointer;
  margin-left: 5px;
  color: #ff691f;
}
</style>
